import PropTypes from 'prop-types';
export var __deprecatedMapping = {};
var propTypes = {
  ActionIconArrowBottom: PropTypes.func,
  ActionIconArrowLeft: PropTypes.func,
  ActionIconArrowRight: PropTypes.func,
  ActionIconArrowTop: PropTypes.func,
  ActionIconBack: PropTypes.func,
  ActionIconCheckmark: PropTypes.func,
  ActionIconChevronBottom: PropTypes.func,
  ActionIconChevronLeft: PropTypes.func,
  ActionIconChevronRight: PropTypes.func,
  ActionIconChevronTop: PropTypes.func,
  ActionIconClose: PropTypes.func,
  ActionIconEye: PropTypes.func,
  ActionIconForward: PropTypes.func,
  ActionIconHeart: PropTypes.func,
  ActionIconMinus: PropTypes.func,
  ActionIconPaperPlane: PropTypes.func,
  ActionIconPlaceholder: PropTypes.func,
  ActionIconPlus: PropTypes.func,
  ActionIconScroll: PropTypes.func,
  ActionIconSearch: PropTypes.func,
  ActionIconShare: PropTypes.func,
  AlertBannerError: PropTypes.func,
  AlertBannerSuccess: PropTypes.func,
  AlertBannerWarning: PropTypes.func,
  AlertBlock: PropTypes.func,
  AlertBlockError: PropTypes.func,
  AlertBlockSuccess: PropTypes.func,
  AlertBlockWarning: PropTypes.func,
  AmountBreakdown: PropTypes.func,
  ArticleDefinition: PropTypes.func,
  ArticlePrimary: PropTypes.func,
  ArticleTertiary: PropTypes.func,
  AtomLabel: PropTypes.func,
  Avatar: PropTypes.func,
  BlockDefinition: PropTypes.func,
  BlockList: PropTypes.func,
  BlockPlain: PropTypes.func,
  BoxSelectorBase: PropTypes.func,
  BoxSelectorOptionBase: PropTypes.func,
  BoxSelectorDetailedOption: PropTypes.func,
  BoxSelectorNPS: PropTypes.func,
  BoxSelectorPricingOption: PropTypes.func,
  ButtonPrimary: PropTypes.func,
  ButtonSecondary: PropTypes.func,
  ButtonTertiary: PropTypes.func,
  ButtonQuaternary: PropTypes.func,
  ButtonRoundPrimary: PropTypes.func,
  ButtonRoundSecondary: PropTypes.func,
  ButtonRoundTertiary: PropTypes.func,
  ButtonRoundQuaternary: PropTypes.func,
  CenteredContent: PropTypes.func,
  MoleculeButtonRoundPrimary: PropTypes.func,
  'ContextMenu.Main': PropTypes.func,
  'ContextMenu.NavigationItem': PropTypes.func,
  'ContextMenu.Separator': PropTypes.func,
  'ContextMenu.SettingsItem': PropTypes.func,
  ContextMenuMain: PropTypes.func,
  ContextMenuNavigationItem: PropTypes.func,
  ContextMenuSeparator: PropTypes.func,
  ContextMenuSettingsItem: PropTypes.func,
  ComboBox: PropTypes.func,
  DialogUnwrapped: PropTypes.func,
  Dropdown: PropTypes.func,
  Field: PropTypes.func,
  'Field.FieldTooltip': PropTypes.func,
  'Field.FieldLink': PropTypes.func,
  FieldSimple: PropTypes.func,
  FieldSimpleExtended: PropTypes.func,
  IconAppLauncher: PropTypes.func,
  IconArrowBottom: PropTypes.func,
  IconArrowLeft: PropTypes.func,
  IconArrowRight: PropTypes.func,
  IconArrowTop: PropTypes.func,
  IconAssets: PropTypes.func,
  IconAssistant: PropTypes.func,
  IconAttachment: PropTypes.func,
  IconBack: PropTypes.func,
  IconBank: PropTypes.func,
  IconBanksCards: PropTypes.func,
  IconBenefits: PropTypes.func,
  IconCalendar: PropTypes.func,
  IconCart: PropTypes.func,
  IconCellphone: PropTypes.func,
  IconCheckmark: PropTypes.func,
  IconClock: PropTypes.func,
  IconClose: PropTypes.func,
  IconCreditCard: PropTypes.func,
  IconDebt: PropTypes.func,
  IconDelivery: PropTypes.func,
  IconDone: PropTypes.func,
  IconDownSlider: PropTypes.func,
  // Deprecated
  IconDownload: PropTypes.func,
  IconElephant: PropTypes.func,
  IconEnvelope: PropTypes.func,
  IconError: PropTypes.func,
  IconExclude: PropTypes.func,
  IconExpired: PropTypes.func,
  IconEye: PropTypes.func,
  IconFeedback: PropTypes.func,
  IconFeedbackConfirmation: PropTypes.func,
  IconFinancial: PropTypes.func,
  IconForward: PropTypes.func,
  IconGlasses: PropTypes.func,
  IconGridViewMode: PropTypes.func,
  IconHamburger: PropTypes.func,
  IconHandMoney: PropTypes.func,
  IconHeart: PropTypes.func,
  IconHelp: PropTypes.func,
  IconInformation: PropTypes.func,
  IconInstallment: PropTypes.func,
  IconLetter: PropTypes.func,
  IconListViewMode: PropTypes.func,
  IconLocation: PropTypes.func,
  IconMonthly: PropTypes.func,
  IconMore: PropTypes.func,
  IconNotification: PropTypes.func,
  IconOrder: PropTypes.func,
  IconOther: PropTypes.func,
  IconPadlock: PropTypes.func,
  IconPaperPlane: PropTypes.func,
  IconPension: PropTypes.func,
  IconPerson: PropTypes.func,
  IconPhone: PropTypes.func,
  IconPlaceholder: PropTypes.func,
  IconPlay: PropTypes.func,
  IconPlus: PropTypes.func,
  IconProduct: PropTypes.func,
  IconProfile: PropTypes.func,
  IconProfileAlternative: PropTypes.func,
  IconRecurring: PropTypes.func,
  IconRefresh: PropTypes.func,
  IconReturn: PropTypes.func,
  IconSalaryIncome: PropTypes.func,
  IconSavings: PropTypes.func,
  IconScale: PropTypes.func,
  IconSearch: PropTypes.func,
  IconServicePoint: PropTypes.func,
  IconSettings: PropTypes.func,
  IconShare: PropTypes.func,
  IconSign: PropTypes.func,
  IconSpeechBubble: PropTypes.func,
  IconSpendingCategories: PropTypes.func,
  IconStores: PropTypes.func,
  IconToDoorDelivery: PropTypes.func,
  IconToDoorDeliveryWithTimeslot: PropTypes.func,
  IconTransfers: PropTypes.func,
  IconTrash: PropTypes.func,
  IconTruck: PropTypes.func,
  IconWallet: PropTypes.func,
  IconWarning: PropTypes.func,
  InformationBlockLabelBase: PropTypes.func,
  Input: PropTypes.func,
  KlarnaLogoFull: PropTypes.func,
  KlarnaLogoSingleLetter: PropTypes.func,
  LinkPrimary: PropTypes.func,
  LinkSecondary: PropTypes.func,
  LinkLegal: PropTypes.func,
  ListItem: PropTypes.func,
  ListDetailsItem: PropTypes.func,
  Loader: PropTypes.func,
  MaskedField: PropTypes.func,
  MenuTab: PropTypes.func,
  'MenuTab.SingleTab': PropTypes.func,
  'MenuTab.Underline': PropTypes.func,
  NavBar: PropTypes.func,
  NavBarActionBase: PropTypes.func,
  NavigationIconAssistant: PropTypes.func,
  NavigationIconHome: PropTypes.func,
  NavigationIconSpending: PropTypes.func,
  NavigationIconShopping: PropTypes.func,
  NavigationIconSustainability: PropTypes.func,
  NavigationIconTodo: PropTypes.func,
  OfferBreakdown: PropTypes.func,
  ParagraphPrimary: PropTypes.func,
  ParagraphSecondary: PropTypes.func,
  ParagraphTertiary: PropTypes.func,
  ParagraphQuaternary: PropTypes.func,
  PaymentMethod: PropTypes.func,
  PaymentSelectorPreview: PropTypes.func,
  PaymentSelectorPreviewAlt: PropTypes.func,
  PinCodeDigit: PropTypes.func,
  PinCodeField: PropTypes.func,
  Preview: PropTypes.func,
  PreviewLink: PropTypes.func,
  PreviewWithOptions: PropTypes.func,
  PrimaryMerchantColorIcon: PropTypes.func,
  ProgressBar: PropTypes.func,
  'Radio.RadioOption': PropTypes.func,
  RadioBullet: PropTypes.func,
  RadioGroup: PropTypes.func,
  RadioResponsive: PropTypes.func,
  SectionContainer: PropTypes.func,
  SectionContainerAction: PropTypes.func,
  SelectorDirect: PropTypes.func,
  SelectorDirectOption: PropTypes.func,
  SelectorLogo: PropTypes.func,
  SelectorLogoOption: PropTypes.func,
  SelectorInput: PropTypes.func,
  SelectorField: PropTypes.func,
  SelectorOptionBase: PropTypes.func,
  SelectorOptions: PropTypes.func,
  SeparatorSecondary: PropTypes.func,
  SiteNavigationLink: PropTypes.func,
  SpacerHorizontal: PropTypes.func,
  SpacerVertical: PropTypes.func,
  SwitchCheckbox: PropTypes.func,
  SwitchToggle: PropTypes.func,
  TitleDefinition: PropTypes.func,
  TitleDisplay: PropTypes.func,
  TitlePrimary: PropTypes.func,
  TitleSecondary: PropTypes.func,
  TitleSubtitle: PropTypes.func,
  TitleTertiary: PropTypes.func,
  Tooltip: PropTypes.func,
  Strong: PropTypes.func,
  UpsellPreview: PropTypes.func
};
export var getStyleSheetPropType = PropTypes.shape(propTypes);
export default propTypes;
//# sourceMappingURL=propTypes.js.map